import { gsap } from './gsap.min';
import { ScrollTrigger } from './ScrollTrigger.min';
// import preloader from './_components/preloader';
import loading from './_components/loading';
import splide from './_components/splide';
import animate from './_components/animate';
import lazy from './_components/lazy';
import lenisScroll from './_components/lenisScroll';
import smoothScroll from './_components/smoothScroll';
import visual from './_components/visual';
import header from './_components/header';
import hamburger from './_components/hamburger';
import faq from './_components/faq';
import parallax from './_components/parallax';

// gsap / ScrollTrigger をグローバルに公開（animate.js 等から参照できるように）
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);
// Android Chrome の URL バー表示/非表示で ScrollTrigger が誤発火するのを防ぐ
ScrollTrigger.config({ ignoreMobileResize: true });

// preloader.init();
loading.init();
splide.init();
animate.init();
lazy.init();
smoothScroll.init();
lenisScroll.init();
visual.init();
header.init();
hamburger.init();
faq.init();
parallax.init();
